import { render, staticRenderFns } from "./Sailboat.vue?vue&type=template&id=99c353a4&scoped=true"
import script from "./Sailboat.vue?vue&type=script&lang=js"
export * from "./Sailboat.vue?vue&type=script&lang=js"
import style0 from "./Sailboat.vue?vue&type=style&index=0&id=99c353a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c353a4",
  null
  
)

export default component.exports